import GlobalService from '@/api/services/GlobalService';
import { NotificationResponseType } from '@/api/services/GlobalService/types';

let request: Promise<NotificationResponseType> | null = null;

// Promo and NotificationPanel both need the notifications list: one shared request per page load
// instead of one per component
export const getNotifications = () => {
  if (!request) {
    request = GlobalService.post<NotificationResponseType>('NOTIFICATIONS_URL', null);
    request.catch(() => {
      request = null;
    });
  }
  return request;
};
